import { Outlet } from "react-router-dom";

const OrdersPageLayout = () => {
  return (
    <><Outlet /></>
  );
};

export default OrdersPageLayout;